import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_API_URL || "https://api.jungleclick.online/api";

const apiClient = axios.create({
    baseURL: API_BASE_URL,
    headers: {
        "Content-Type": "application/json"
    }
});

apiClient.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem("accessToken");
        if (token) {
            config.headers["Authorization"] = "Bearer " + token;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

apiClient.interceptors.response.use(
    (response) => {
        return response;
    },
    async (error) => {
        const originalRequest = error.config;
        if (error.response?.status === 401 && !originalRequest._retry) {
            originalRequest._retry = true;
            try {
                const refreshToken = localStorage.getItem("refreshToken");
                if (refreshToken) {
                    const response = await axios.post(API_BASE_URL + "/auth/refresh-token", {
                        refreshToken,
                    });

                    const { accessToken } = response.data;
                    localStorage.setItem("accessToken", accessToken);
                    originalRequest.headers["Authorization"] = "Bearer " + accessToken;
                    return apiClient(originalRequest);
                }
            } catch (refreshError) {
                localStorage.removeItem("accessToken");
                localStorage.removeItem("refreshToken");
                window.location.href = "/login";
                return Promise.reject(refreshError);
            }
        }
        return Promise.reject(error);
    }
);

export const getAccounts = async () => {
    try {
        const response = await apiClient.get("/accounts");
        return response.data;
    } catch (error) {
        throw new Error(error.response?.data?.message || "Error al obtener cuentas");
    }
}

export const getProfiles = async () => {
    try {
        const response = await apiClient.get("/accounts/profiles");
        return response.data;
    } catch (error) {
        throw new Error(error.response?.data?.message || "Error al obtener perfiles");
    }
}

export const getUsers = async () => {
    try {
        const response = await apiClient.get("/users");
        return response.data;
    } catch (error) {
        throw new Error(error.response?.data?.message || "Error al obtener usuarios");
    }
}

export const registerNewUser = async (userData) => {
    try {
        const response = await apiClient.post("/register", userData);
        return response.data;
    } catch (error) {
        throw new Error(error.response?.data?.message || "Error al registrar usuario");
    }
}

export const registerUser = async (userData) => {
    try {
        const response = await apiClient.post("/auth/register", userData);
        return response.data;
    } catch (error) {
        throw new Error(error.response?.data?.message || "Error al registrar usuario");
    }
};

export const loginUser = async (credentials) => {
    try {
        const response = await apiClient.post("/auth/login", credentials);
        if (response.data.accessToken)
            localStorage.setItem("accessToken", response.data.accessToken);
        if (response.data.refreshToken)
            localStorage.setItem("refreshToken", response.data.refreshToken);
        return response.data;
    } catch (error) {
        throw new Error(error.response?.data?.message || "Error al iniciar sesión");
    }
};

export const logoutUser = () => {
    localStorage.removeItem("accessToken");
    localStorage.removeItem("refreshToken");
};

export const isAuthenticated = () => localStorage.getItem("accessToken");

export const getCurrentUser = async () => {
    try {
        const response = await apiClient.post("/auth/user");
        return response.data;
    } catch (error) {
        throw new Error(error.response?.data?.message || "Error al obtener usuario actual");
    }
};

export const getUserToEdit = async (id) => {
    try {
        const response = await apiClient.get(`/getUserToEdit/${id}`);
        return response;
    } catch (error) {
        throw new Error(error.response?.data?.message || "Error al obtener usuario a Editar");
    }
};

export const updateUser = async (userData, id) => {
    try {
        const response = await apiClient.put(`/updateUser/${id}`, userData);
        return response.data;
    } catch (error) {
        throw new Error(error.response?.data?.message || "Error al Actualizar el usuario");
    }
}

export const deleteUser = async (idUser) => {
    try {
        console.log(idUser);
        //para metodo delete de axios, el body se envia a partir de un campo "data"
        const response = await apiClient.delete(`/deleteUser`, { data: { id: idUser } });
        return response.data;
    } catch (error) {
        throw new Error(error.response?.data?.message || "Error al Eliminar el Usuario");
    }
};

export const restablecerContrasena = async (email, newPassword) => {
    try {
        const response = await apiClient.post("/restablecerContrasena", { email: email, newPassword: newPassword });
        return response;
    } catch (error) {
        throw new Error(error.response?.data?.message || "Error al restablecer contraseña");
    }
}

export const getDailyReport = async (date, accountID) => {
    try {
        const response = await apiClient.get("/report/" + date + "/" + accountID);
        return response.data;
    } catch (error) {
        throw new Error(error.response?.data?.message || "Error al obtener reportes");
    }
};

export const updateReportAPI = async (data, reportId) => {
    try {
        const response = await apiClient.put("/report/update", { data: JSON.stringify(data), reportId: reportId });
        return response.data;
    } catch (error) {
        throw new Error(error.response?.data?.message || "Error al actualizar reportes");
    }
}

export const getUpdateData = async (id) => {
    try {
        console.log("Entro");
        const response = await apiClient.get("/report/getUpdateData/" + id.toString());
        console.log(response);

        return response.data
    } catch (error) {
        throw new Error(error.response?.data?.message || "Error al obtener la nueva data");
    }
}

export const createParametro = async (data, id) => {
    try {
        const response = await apiClient.post("/parametros", { ...data, accountID: id });
        return response.data;
    } catch (error) {
        throw new Error(error.response?.data?.message || "Error al registrar el parametro");
    }
}

export const updateParametro = async (data, id) => {
    try {
        const response = await apiClient.put("/parametros/" + id, data);
        return response.data;
    } catch (error) {
        throw new Error(error.response?.data?.message || "Error al actualizar el parametro");
    }
}

export const getParametros = async (id) => {
    try {
        const response = await apiClient.get("/parametros/list/" + id);
        return response.data;
    } catch (error) {
        throw new Error(error.response?.data?.message || "Error al obtener los parametros");
    }
}

export const getParametroByID = async (id) => {
    try {
        const response = await apiClient.get("/parametros/" + id);
        return response.data;
    } catch (error) {
        throw new Error(error.response?.data?.message || "Error al obtener los parametros");
    }
}

export const deleteParametro = async (id) => {
    try {
        const response = await apiClient.delete("/parametros/" + id);
        return response.data;
    } catch (error) {
        throw new Error(error.response?.data?.message || "Error al eliminar parámetro");
    }
}

export const getReportList = async (id) => {
    try {
        const response = await apiClient.get("/report/lista/" + id)
        return response.data;
    } catch (error) {
        throw new Error(error.response?.data?.message || "Error al obtener los reportes");
    }
};

export const getExpressList = async (id) => {
    try {
        const response = await apiClient.get("/express/lista/" + id)
        return response.data;
    } catch (error) {
        throw new Error(error.response?.data?.message || "Error al obtener términos");
    }
}

export const createExpress = async (data, id) => {
    try {
        console.log(data);
        const response = await apiClient.post("/express", { ...data, accountID: id })
        return response.data;
    } catch (error) {
        throw new Error(error.response?.data?.message || "Error al negativizar términos");
    }
}

export const createSugerencia = async (data, account, date, user) => {
    try {
        const response = await apiClient.post("/sugerencias", { data: data, date: date, account: account, user: user });
        return response.data
    } catch (error) {
        throw new Error(error.response?.data?.message || "Error al realizar sugerencia");
    }
}

export const getSugerencias = async () => {
    try {
        const response = await apiClient.get("/sugerencias");
        return response.data
    } catch (error) {
        throw new Error(error.response?.data?.message || "Error al obtener sugerencias");
    }
}

export const getMergeReports = async (accountID) => {
    try {
        const response = await apiClient.get("/report/mergeReports/" + accountID);
        return response.data
    } catch (error) {
        throw new Error(error.response?.data?.message || "Error al obtener reportes");
    }
}

export const createMergeReport = async (data, accountID) => {
    try {
        const response = await apiClient.post("/report/mergeReports/" + accountID, data);
        console.log(response.data);

        return response.data
    } catch (error) {
        throw new Error(error.response?.data?.message || "Error al crear reporte");
    }
}

export const processReportsAPI = async (accountID, date, type) => {
    try {
        const response = await apiClient.post("/report/regenerate/" + accountID, {
            date: date,
            type: type
        });
        console.log(response.data);

        return response.data
    } catch (error) {
        throw new Error(error.response?.data?.message || "Error al crear reporte");
    }
}

export default apiClient;